module.exports = __webpack_public_path__ + "img/14-1_06.af4ba216.jpg";